import { Transform } from 'class-transformer';
import { DateUtil } from '@shared/util/date.util';

export class PatientNoteCalendarDayDTO {
  @Transform(DateUtil.dateConversion)
  public date: Date;

  public patientNoteId: number;
}
